{
  "shellWaitLabel": "Ladevorgang läuft"
}
